<app-impact-modal #openImpact [modalTitle]="app.text.impact.impact">
</app-impact-modal>
<app-modal
  #deleteImpactModal
  [modalMessage]="app.text.impact.deleteMessage"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="deleteSelectedImpact(app.impact.currentImpact)"
></app-modal>

<div class="where-used-card">
  <!-- Different text is displayed before where used table based on the current view -->
  @if (!hideDisplayText && !app.overrideMpnFields.openOverrideModal) {
    <div
      class="where-used-overview"
      >
      <div class="where-used-overview-header">
        <div class="where-used-overview-icon">
          <i class="fas fa-sitemap"></i>
        </div>
        <div>
          <h3>{{ app.text.part.whereUsed }}</h3>
          <p>{{ app.text.part.whereUsedDescription }}</p>
        </div>
      </div>
      @if (hasPart && !shouldDisplayText()) {
        <div
          class="where-used-properties-panel"
          >
          <div class="where-used-property-row">
            @if (app.customer === 'lre') {
              <span class="where-used-property-label">
                {{ app.field.getLabel("thread.artNumber") }}:&nbsp;
              </span>
            }
            @if (app.customer !== 'lre') {
              <span class="where-used-property-label">
                {{ app.field.getLabel("part.partNumber") }}:&nbsp;
              </span>
            }
            <span class="where-used-property-value">{{ part._id }}</span>
          </div>
          @if (totalUsages > 0) {
            <div class="where-used-property-row">
              <span class="where-used-property-label">
                {{ app.text.impact.sumOfUsages }}&nbsp;
              </span>
              <span class="where-used-property-value">{{ totalUsages }}</span>
            </div>
          }
          @if (freqUse !== 0) {
            <div class="where-used-property-row">
              <span class="where-used-property-label">
                {{ app.text.impact.freqUse }}&nbsp;
              </span>
              <span class="where-used-property-value">{{ freqUse }}</span>
            </div>
          }
          @if (mpns.length > 0) {
            <div class="where-used-property-row mpn-row">
              <span class="where-used-property-label">
                {{ app.text.RM.manufacturerPartNumber }}:&nbsp;
              </span>
              <span class="where-used-property-value mpn-links">
                @for (o of mpns; track o) {
                  <a
                    class="links pointer"
                    (click)="app.routing.openInNewTab(null, 'impact.manufacturers', o.id)"
                    >{{ o.mpn }}
                  </a>
                }
              </span>
            </div>
          }
        </div>
      }
      @if (shouldDisplayText()) {
        <div class="where-used-properties-panel">
          <div class="where-used-property-row">
            <span class="where-used-property-label">
              {{ app.field.getLabel(app.fieldId.part.partNumber) }}:&nbsp;
            </span>
            <span class="where-used-property-value">
              {{ app.treeRow.currentPart.partNumber }}
            </span>
          </div>
          <div class="where-used-property-row">
            <span class="where-used-property-label">
              {{ app.field.getLabel(app.fieldId.part.description) }}:&nbsp;
            </span>
            <span class="where-used-property-value">
              {{ app.treeRow.currentPart.description }}
            </span>
          </div>
        </div>
      }
    </div>
  }

  <!-- Where used table for RM clients -->
  <div class="tableFixHead">
    <table class="table table-striped">
      <thead>
        <tr class="p-1">
          <!-- RMClientColumns based on each customer -->
          @for (column of columns; track column) {
            <th class="p-1">
              <div>
                <span
              (click)="
                app.table.toggleSortDirection(column);
                setVehiclesForSorting(vehicles);
                resetNodes()
              "
                  >{{ specialLogicLabels(column) }}</span
                  >&nbsp;
                  @if (column === app.table.sortField) {
                    <span>
                      @if (app.table.sortDirection === 1) {
                        <i
                          class="fa fa-chevron-up"
                        ></i>
                      }
                      @if (app.table.sortDirection === -1) {
                        <i
                          class="fa fa-chevron-down"
                        ></i>
                      }
                    </span>
                  }
                </div>
              </th>
            }
            <!-- Action column -->
            @if (
              threadPage &&
              app.permission.impact.edit &&
              !app.overrideMpnFields.openOverrideModal
              ) {
              <th
                class="p-1"
                >
                {{ app.field.getLabel("impact.actions") }}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (impact of vehicles; track impact; let i = $index) {
            <tr
              [ngClass]="{ 'blue-striped': app.view !== 'thread' }"
              >
              <!-- RMClientColumns based on each customer -->
              @for (column of columns; track column) {
                <td class="p-1">
                  <div
                    >
                    @switch (app.table.getColumnTypeDisplay(column.split('.')[1])) {
                      @case ('artNumber') {
                        <div class="pull-left impact-art-number">
                          <span
                            class="impact-indent"
                            [style.width.px]="(impact.parent?.length || 0) * 18"
                          ></span>
                          @if (impact.impacts.length > 0) {
                            <span>
                              @if (!openNodes.has(impact.index)) {
                                <i
                                  class="far fa-plus icon-gray pointerIcon p-1 pointer"
                                  (click)="toggleNode(impact); $event.stopPropagation()"
                                ></i>
                              }
                              @if (openNodes.has(impact.index)) {
                                <i
                                  class="fa fa-minus icon-gray pointerIcon p-1 pointer"
                                  (click)="toggleNode(impact); $event.stopPropagation()"
                                ></i>
                              }
                              @if (!impact.parent) {
                                <span class="pointer">
                                  @if (
                                    app.view == 'thread' &&
                                    !app.overrideMpnFields.openOverrideModal
                                    ) {
                                    <span
                                      (click)="openImpact.open(impact)"
                                      >
                                      {{ impact.artNumber }}</span
                                      >
                                    }
                                  </span>
                                }
                                @if (
                                  impact.parent ||
                                  app.view != 'thread' ||
                                  app.overrideMpnFields.openOverrideModal
                                  ) {
                                  <span
                                    >{{ impact.artNumber }}</span
                                    >
                                  }
                                </span>
                              }
                              @if (impact.impacts.length === 0 && app.customer !== 'knds') {
                                <span
                                  >
                                  <i class="far fa-minus icon-gray pointerIcon p-1"> </i>
                                  <span class="impact-art-number-text">
                                    {{ impact.artNumber }}
                                  </span>
                                </span>
                              }
                              @if (impact.impacts.length === 0 && app.customer === 'knds') {
                                <span
                                  class="pointer"
                                  >
                                  @if (
                                    app.view == 'thread' &&
                                    !app.overrideMpnFields.openOverrideModal
                                    ) {
                                    <span
                                      (click)="openImpact.open(impact)"
                                      >
                                      <i class="far fa-minus icon-gray pointerIcon p-1"> </i>
                                      <span class="impact-art-number-text">
                                        {{ impact.artNumber }}
                                      </span></span
                                      >
                                    }
                                    @if (
                                      app.view != 'thread' ||
                                      app.overrideMpnFields.openOverrideModal
                                      ) {
                                      <span
                                        >
                                        <i class="far fa-minus icon-gray pointerIcon p-1"> </i>
                                        <span class="impact-art-number-text">
                                          {{ impact.artNumber }}
                                        </span>
                                      </span>
                                    }
                                  </span>
                                }
                              </div>
                            }
                            @case ('normal') {
                              <div>
                                <span>{{ impact[column.split(".")[1]] }}</span>
                              </div>
                            }
                            @case ('optionText') {
                              <div>
                                <span>
                                  {{ app.field.getOptionText(column, impact[column.split(".")[1]]) }}
                                </span>
                              </div>
                            }
                            @case ('decimalNumber') {
                              <div>
                                @if (impact[column.split('.')[1]] > -1) {
                                  <span>
                                    {{
                                    app.field.formatNumberWithDecimals(
                                    impact[column.split(".")[1]],
                                    2
                                    )
                                    }}
                                  </span>
                                }
                              </div>
                            }
                          }
                        </div>
                      </td>
                    }
                    <!-- Action column -->
                    @if (
                      !impact.parent &&
                      threadPage &&
                      !app.overrideMpnFields.openOverrideModal
                      ) {
                      <td
                        class="p-1 text-center"
                        >
                        @if (app.permission.impact.edit) {
                          <a
            (click)="
              app.impact.currentImpact = impact; deleteImpactModal.open()
            "
                            class="pointer"
                            >
                            <i class="fa fa-trash"></i>
                          </a>
                        }
                      </td>
                    }
                    @if (impact.parent && threadPage) {
                      <td></td>
                    }
                  </tr>
                }
                <!-- No results line -->
                @if (vehicles.length === 0) {
                  <tr>
                    <td colspan="99" class="text-center">
                      {{ app.text.app.noResults }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
